import React from 'react'
import { MEDICINE_CATEGORY_LIST } from 'constants/path'
import { SectionGrant } from 'components/functional'
import { canShowSidebar } from 'policies/MedicineCategoryPolicy'
import MenuItem from '../MenuItem'
import { useQuery } from '../useQuery'

type Props = ReturnType<typeof useQuery>

export const MedicineCategoryMenuItem: React.FC<Props> = ({ viewer }) => {
  return (
    <SectionGrant authorized={canShowSidebar(viewer)}>
      <MenuItem href={MEDICINE_CATEGORY_LIST}>薬剤一覧</MenuItem>
    </SectionGrant>
  )
}
